/**
 * Util function to use outside of components only (use `useNavigate` hook otherwise),
 * allows to push on the history stack
 * @param location: the location to go to
 */
export const pushHistory = (location: string) => {
  //browserHistory.push(location);
  window.history.pushState({}, '', location);
};
